export const Directory = 'directory'

export const File = 'file'
